import { AppSidebar } from '@/components/appSidebar';
import { SidebarProvider } from '@/components/ui/sidebar';
import { authBeforeLoad, useRedirectToLoginIfNoAuth } from '@/lib/authGuard';
import { AppDevtools } from '@/components/appDevtools';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app')({
  component: RouteComponent,
  beforeLoad: authBeforeLoad,
});

function RouteComponent() {
  useRedirectToLoginIfNoAuth();

  return (
    <SidebarProvider>
      <AppSidebar />
      <div className="p-10 flex-1 bg-fill-surface-strong overflow-auto">
        <Outlet />
      </div>
      <AppDevtools />
    </SidebarProvider>
  );
}
